import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant, { Lazyload } from 'vant'
import 'vant/lib/index.css'
import './style/main.scss'
import api from '@/api/api'
import Loading from '@/utils/loading'
import { Base64 } from 'js-base64'
import formatDate from '@/utils/formatDate'
import wx from 'weixin-js-sdk'
import emoji from '@/utils/emoji'
Vue.directive('emoji', emoji)
Vue.use(Vant)
Vue.use(Lazyload)
Vue.config.productionTip = false
Vue.use(Loading)
global.wx = wx
Vue.prototype.$Base64 = Base64
Vue.prototype.$api = api
Vue.prototype.$format = formatDate
let vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default vm
